import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import { ButtonBase } from "../../../common/components/form";
import { useGetPaymentStatus, useReduxAccount } from "../../hooks";
import * as API from "../../lib/api.js";
import OverlayCustom from "../Overlay";
import PaymentMethodChosing from "./PaymentMethodChoosing.jsx";

export default function PaymentOverlay() {
    const { t } = useTranslation();
    const location = useLocation();
    const history = useHistory();
    const domFormWrap = React.useRef();

    const [list, setList] = React.useState([]);
    const [overlayShows, setOverlayShows] = React.useState(false);
    const [paymentStatus, setPaymentStatus] = React.useState(null);
    const [paymentMethodChosing, setPaymentMethodChosing] = React.useState(false);

    const { free, needToPay, notPayed, daysToPublicBlock, daysToAdminBlock, daysToDeleteAccount } =
        useGetPaymentStatus();

    const { id_plan: selectedPlan, subscription_active, payment_system } = useReduxAccount();

    React.useEffect(() => {
        const url = new URLSearchParams(location.search);
        setPaymentStatus(url.get("payment"));
        API.PlanList().then(res => {
            if (!res?.ok || !res?.list) {
                return;
            }
            setList(res.list);
        });
    }, [location]);

    function onCancel() {
        history.replace("/dashboard");
        setOverlayShows(false);
        setPaymentStatus(null);
        setPaymentMethodChosing(false);
    }

    function onLogout() {
        history.replace("/logout");
    }

    function onPaymentMethodChosing() {
        if (!payment_system) {
            return setPaymentMethodChosing(true);
        }
        return getPayment(payment_system);
    }

    function getPayment(system) {
        API.GetPaymentForm(system)
            .then(({ html }) => {
                if (!domFormWrap.current) {
                    return;
                }

                domFormWrap.current.innerHTML = html;
                let form = domFormWrap.current.querySelector("form");
                form && form.submit();
            })
            .catch(e => console.warn("[Error at PaymentOverlay]", e));
    }

    if (free) {
        return null;
    }

    return (
        <>
            <div ref={domFormWrap} style={{ display: "none" }}></div>

            {needToPay && (
                <div className="need-to-pay">
                    {t("NeedToPayMessage")}{" "}
                    {daysToPublicBlock > 0 && (
                        <span>
                            {t("DaysToPublicBlock")}
                            {daysToPublicBlock}
                        </span>
                    )}
                    {daysToAdminBlock <= 14 && (
                        <span>
                            {t("DaysToAdminBlock")}
                            {daysToAdminBlock}
                        </span>
                    )}
                    <button onClick={onPaymentMethodChosing}>
                        {subscription_active === false ? t("RestoreSubscribtion") : t("Pay")}
                    </button>
                </div>
            )}

            {(overlayShows || notPayed) && (
                <OverlayCustom>
                    <div className="overlay-payment-logo">
                        <img src="/android-chrome-512x512.png" alt="PGBLDR.com" width={"200px"} />
                    </div>

                    <div className="overlay-payment-texts">
                        <p>{t("OverlayPayment1")}</p>
                        <p>{t("OverlayPayment2")}</p>

                        {notPayed && daysToDeleteAccount >= 0 && (
                            <p>
                                {t("DaysToDeleteAccount")}
                                {daysToDeleteAccount}
                            </p>
                        )}
                    </div>

                    <div className="overlay-payment-buttons">
                        {notPayed && (
                            <ButtonBase solid onClick={onLogout}>
                                {t("Logout")}
                            </ButtonBase>
                        )}

                        <a href="mailto:support@pgbldr.com" style={{ textDecoration: "none" }}>
                            <ButtonBase solid>{t("ContactUs")}</ButtonBase>
                        </a>

                        <ButtonBase invert onClick={onPaymentMethodChosing}>
                            {subscription_active === false ? t("RestoreSubscribtion") : t("Pay")}
                        </ButtonBase>
                    </div>
                </OverlayCustom>
            )}

            {(paymentStatus === "success" || paymentStatus === "subscribed") && (
                <OverlayCustom>
                    <div className="overlay-payment-logo">
                        <img src="/android-chrome-512x512.png" alt="PGBLDR.com" width={"200px"} />
                    </div>

                    <div className="overlay-payment-texts">
                        <p>{t("OverlayPaymentSuccess")}</p>
                    </div>

                    <div className="overlay-payment-buttons">
                        <ButtonBase invert onClick={onCancel}>
                            {t("Continue")}
                        </ButtonBase>
                    </div>
                </OverlayCustom>
            )}

            {paymentStatus === "false" && (
                <OverlayCustom>
                    <div className="overlay-payment-logo">
                        <img src="/android-chrome-512x512.png" alt="PGBLDR.com" width={"200px"} />
                    </div>

                    <div className="overlay-payment-texts">
                        <p>{t("OverlayPaymentError1")}</p>
                        <p>{t("OverlayPaymentError2")}</p>
                    </div>

                    <div className="overlay-payment-buttons">
                        <ButtonBase invert onClick={onCancel}>
                            {t("Continue")}
                        </ButtonBase>
                    </div>
                </OverlayCustom>
            )}

            <PaymentMethodChosing
                show={paymentMethodChosing}
                header={t("PaymentMethodChoosing")}
                text={t("PaymentMethodChoosingText")}
                planToChange={list && list[selectedPlan - 1]}
                actions={[
                    {
                        onClick: () => getPayment("paypal"),
                        text: t("PayPal"),
                        props: { invert: true },
                    },
                    {
                        onClick: () => getPayment("liqpay"),
                        text: t("LiqPay"),
                        props: { invert: true },
                    },
                    { onClick: onCancel, text: t("Cancel") },
                ]}
            />
        </>
    );
}
